import { useLingui } from '@lingui/react/macro'

export type CurrencyType = 'EUR' | 'USD' | 'GBP'

/**
 * Format a price to 2 decimal places and strip trailing zeros if the price is an integer
 * @returns A function that formats a price in cents to the given currency
 */
export const useFormatPrice = () => {
	const { i18n } = useLingui()

	return (price: number, currency: CurrencyType) => {
		return i18n.number(price / 100, {
			style: 'currency',
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
			trailingZeroDisplay: 'stripIfInteger',
			currency,
		})
	}
}
